import React from 'react'
import { Link } from 'react-router-dom'
import {motion} from "motion/react"

export default function PageSearchItemModified({ id,name , cat , website , fanCount , location ,verified }) {
    const formatNumber = (num) => {
        if (num >= 1e9) return (num / 1e9).toFixed(1) + " B";
        if (num >= 1e6) return (num / 1e6).toFixed(1) + " M";
        if (num >= 1e3) return (num / 1e3).toFixed(1) + " K";
        return num;
      };
  return (
    <motion.div className='body-row'
    initial={{
      opacity : 0 , 
      translateX : -50 , 
      transition :{duration : 1}
    }}
    
    whileInView={{
      opacity : 1 , 
      translateX : 0
    }}>
        <p className='cell'>{name}</p>
        <p className='cell'>{cat}</p>
        <p className='cell'> { formatNumber(fanCount) }</p>
        <p className='cell'><a style={{display :"block" , width : "160px"}} className='website-link'  href={website} target='_blank'>{website}</a></p>
        <p className='cell cell-address'> {location?.country} {location?.city}  {location?.street} </p>
        <div className={`cell  ${verified  ?'verififed-cell' :'not-verififed-cell' }`}><p>{verified ? "Verified" : "Not Verified"}</p></div>
        <div className='cell'> 
            <Link className='get-post-btn' to={`${id}`}><button >Get Posts</button>
            </Link> 
        </div>
    </motion.div>
  )
}
